export default "__VITE_PUBLIC_ASSET__1e429107__"